import React from "react"
import "./icon.module.scss"

interface IconProps {
    children: string
    color?: string
    size?: string
}
export default class Icon extends React.Component<
    IconProps,
    {
        content: string | null
        loaded: boolean
        failed?: true
    }
> {
    state = {
        content: null,
        loaded: false,
    }

    async componentDidMount(): Promise<void> {
        const imageUrl = new URL(this.props.children, import.meta.url)

        await fetch(imageUrl.toString())
            .then(async (response) => {
                this.setState({
                    loaded: true,
                    content: await response.text(),
                })
            })
            .catch(() =>
                this.setState({
                    content: null,
                    loaded: false,
                    failed: true,
                })
            )
    }

    render(): JSX.Element {
        return (
            <i
                className="anio-icon"
                style={{
                    color: this.props.color,
                    width: this.props.size,
                    height: this.props.size,
                }}
                dangerouslySetInnerHTML={{ __html: this.state.content || "" }}
            ></i>
        )
    }
}
